import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  Colors,
  Divider,
  Flex,
  IconChevronRight,
  PrimaryButton,
  Typography,
} from '@banhala/ui-kit';

type InquiryGoodsQuestionProps = {
  onClickNotice: () => void;
  onClickInquiry: () => void;
};

/**
 * 문의 탭의 안내 행 + 상품 문의 섹션.
 *
 * ably-webview-react `pages/goods/_component/Contact/InquiryGoodsQuestion.tsx` 와 맞춘 형태다.
 *
 * ⚠️ 도착보장(3PL) 문의 섹션은 **의도적으로 이식하지 않았다.** 웹뷰에도 코드는 있지만
 * `FORCE_SHOW_THIRD_PL_INQUIRY = false` 로 강제 비노출 상태다(추후 다시 열릴 수 있음 —
 * https://ablycorp.slack.com/archives/C0AQHGFQS2C/p1782106181234869). 다시 열 때 함께 추가한다.
 */
export const InquiryGoodsQuestion: React.FC<InquiryGoodsQuestionProps> = ({
  onClickNotice,
  onClickInquiry,
}) => {
  return (
    <>
      <Flex.Row
        alignItems="center"
        justifyContent="space-between"
        padding={{ horizontal: 16, vertical: 24 }}
        onPress={onClickNotice}
      >
        <Typography type="h5" color="content_primary">
          배송 / 결제 / 교환 / 반품 안내
        </Typography>
        <IconChevronRight
          width={16}
          height={16}
          fill={Colors.content_tertiary}
        />
      </Flex.Row>
      <Divider size="small" />
      <Flex
        alignItems="center"
        padding={{ top: 40, bottom: 34, horizontal: 16 }}
        rowGap={16}
      >
        <TShirtIcon />
        <Flex alignItems="center" rowGap={4}>
          <Typography type="subtitle1" color="content_primary">
            상품에 대해 궁금한 점 있으신가요?
          </Typography>
          <Flex alignItems="center">
            <Typography type="body2" color="content_secondary">
              사이즈 / 옵션 / 재입고 등의
            </Typography>
            <Typography type="body2" color="content_secondary">
              상품 문의는 마켓에서 답변해드려요
            </Typography>
          </Flex>
        </Flex>
        <PrimaryButton
          variant={'fill'}
          size="small"
          outline
          color="gray"
          onPress={onClickInquiry}
        >
          상품 문의하기
        </PrimaryButton>
      </Flex>
    </>
  );
};

/** 웹뷰 원본의 인라인 SVG(파란 티셔츠) 이식. path·fill 동일. */
const TShirtIcon = () => (
  <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
    <Path
      d="M20.7718 4.82302C21.172 4.9302 21.4095 5.34152 21.3022 5.74166L20.1372 10.0881C20.03 10.4883 19.6185 10.7257 19.2184 10.6183L17.9999 10.2913V20.25C17.9999 20.6642 17.6641 21 17.2499 21H6.74988C6.33567 21 5.99988 20.6642 5.99988 20.25V10.2576L4.65388 10.6185C4.25374 10.7258 3.8424 10.4883 3.7352 10.0881L2.57066 5.74145C2.46347 5.34138 2.70087 4.93017 3.10093 4.82293L8.48106 3.38084C8.70626 3.32048 8.93002 3.47923 8.98468 3.70588C9.30211 5.02212 10.4873 6 11.901 6C13.3198 5.99991 14.5074 5.01476 14.8194 3.69122C14.873 3.46345 15.0974 3.30329 15.3234 3.36383L20.7718 4.82302Z"
      fill="#6093FC"
    />
  </Svg>
);
